'use client'
import { useMessages, useTranslations } from 'next-intl'
import { useEffect, useRef, useState } from 'react'
import Image from 'next/image'
import { Link, usePathname } from 'navigation'
import TextWithLineBreaks from '@/components/TextWithlineBreak'
import { clientsImages } from 'src/constants'
const ClientsSection = () => {
  const pathname = usePathname()
  const t = useTranslations('clients-page')
  const messages = useMessages()
  const allSections = Object.keys(messages['clients-page'].All)
  const tabType = pathname.includes('client/')
    ? pathname.split('client/')[1]
    : null
  const filterSections = tabType
    ? allSections.filter(
        (section) =>
          t(`All.${section}.companyCategory`) ===
          tabType.slice(0, 1).toUpperCase() + tabType.slice(1)
      )
    : allSections
  const [FilteredSections, setFilteredSections] = useState(filterSections)
  useEffect(() => {
    if (pathname.includes('client/')) {
      const tabType = pathname.split('client/')[1]
      const filterSections = allSections.filter(
        (section) =>
          t(`All.${section}.companyCategory`) ===
          tabType.slice(0, 1).toUpperCase() + tabType.slice(1)
      )
      setFilteredSections(filterSections)
    }
  }, [pathname])
  return (
    <section>
      <div className='flex flex-col'>
        {FilteredSections.map((sec, index) => {
          const services = Object.keys(
            messages['clients-page'].All[sec]['services-sec'].services
          )
          return (
            <article
              className={`p-[30px] ${index % 2 !== 0 ? 'bg-[#fbfbfb]' : 'bg-[#fff]'}`}
              key={sec}
            >
              <div className='container  pb-[25px] md:pt-[18px] md:pb-[43px]'>
                <div className='mb-4'>
                  <Image
                    src={clientsImages[t(`All.${sec}.companyName`)]}
                    alt={t(`All.${sec}.companyName`)}
                    className=''
                    width={150}
                    height={100}
                  />
                </div>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-x-[30px] '>
                  <div className='md:pr-[50px]'>
                    <h3 className='heading-common col-span-9 md:col-span-10 mb-8'>
                      {t(`All.${sec}.heading`)}
                    </h3>
                    <div className='mb-[30px] md:text-[16px] text-[18px]'>
                      <h5 className=' font-normal mb-[14px]'>
                        {t(`All.${sec}.challenge.title`)}
                      </h5>
                      <p className='leading-[1.6] font-light '>
                        {t(`All.${sec}.challenge.description`)}
                      </p>
                    </div>
                    <div className='mb-[30px]'>
                      <h5 className='text-[16px] font-normal mb-[14px]'>
                        {t(`All.${sec}.solution.title`)}
                      </h5>
                      <p className='leading-[1.6] font-light '>
                        {t(`All.${sec}.solution.description`)}
                      </p>
                    </div>
                    <div className=''>
                      <h5 className='text-[16px] font-normal mb-[14px]'>
                        {t(`All.${sec}.services-sec.title`)}
                      </h5>
                      <div className='grid grid-cols-1 md:grid-cols-2 mb-[30px] text-[16px] md:text-[15px] md:mb-0 w-fit gap-4'>
                        {services.map((service) => (
                          <div
                            key={service}
                            className='flex w-fit items-center gap-3'
                          >
                            <Image
                              src='https://storage.googleapis.com/rolzo-static-bucket/icons/tick_box.png'
                              alt={t(`All.${sec}.services-sec.services.${service}`)}
                              width={16}
                              height={16}
                            />
                            <span className='font-light'>
                              {t(`All.${sec}.services-sec.services.${service}`)}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className='flex flex-col'>
                    <div
                      style={{
                        backgroundColor: t(
                          `All.${sec}.feedback-section.bg-color`
                        ),
                        color: t.has(`All.${sec}.feedback-section.text-color`)
                          ? t(`All.${sec}.feedback-section.text-color`)
                          : '#fff',
                      }}
                      className={`p-12 rounded-[15px] text-[#fff] text-[18px] md:text-[16px] font-light mb-[35px]`}
                    >
                      <p className='leading-[1.6] font-light mb-[35px] text-[18px] md:text-[16px]'>
                        {t(`All.${sec}.feedback-section.feedback`)}
                      </p>
                      <p>
                        {t.rich(`All.${sec}.feedback-section.authorPosition`, {
                          bold: (chunks) => (
                            <span className='font-normal'>{chunks}</span>
                          ),
                        })}
                      </p>
                    </div>
                    <TextWithLineBreaks
                      elementClassName='leading-[1.6] font-light mb-[35px]'
                      lineBreakClassname='hidden xl:block'
                      textKey={`All.${sec}.companyBrief`}
                      t={t}
                      element='p'
                    />
                    <p className='text-[20px] md:text-[16px]'>
                      {t.rich(`All.${sec}.companyUrl`, {
                        goldcolor: (chunks) => (
                          <Link
                            target='_blank'
                            href={`https://${chunks}`}
                            className='text-rolzo-gold'
                          >
                            {chunks}
                          </Link>
                        ),
                      })}
                    </p>
                  </div>
                </div>
              </div>
            </article>
          )
        })}
      </div>
    </section>
  )
}

export default ClientsSection
